export const productName = 'MEGAPACK CRIMINALÍSTICA LISTO';
export const productShortName = 'Megapack Criminalística Listo';
export const productImage = 'https://cdn.magicpatterns.com/uploads/8z21HZrrodEMGJS5JuAn8Z/MOCKUP_2.47.44_p._m..png';

export const checkoutUrl = 'https://megapack-criminalistica-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de la Criminalística',
  'Tomo 2 — Investigación del Lugar de los Hechos',
  'Tomo 3 — Indicios, Evidencias y Ciencias Forenses',
  'Tomo 4 — Dactiloscopía, Huellas y Sistemas de Identificación',
  'Tomo 5 — Biología y Genética Forense',
  'Tomo 6 — Documentos, Escritura y Análisis Forense',
  'Tomo 7 — Química y Toxicología Forense',
  'Tomo 8 — Criminalística Digital y Nuevas Tecnologías',
  'Tomo 9 — Enseñanza de la Criminalística: Planificación, Actividades y Casos',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones Problemáticas',
  'Bono 4 — Diccionario Docente de 200 Conceptos',
  'Bono 5 — 50 Proyectos de Investigación y Análisis',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de actividades sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de criminalística complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la criminalística',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
